// src/services/referralApiServices.js
import { api } from './apiServices'; //

// --- COMMISSION PLANS ---

export const getCommissionPlans = async (filters = {}) => {
  try {
    const response = await api.get('/admin/affiliate/commissions/plans', { params: filters });
    return response.data;
  } catch (error) {
    console.error("Error fetching commission plans:", error);
    throw error;
  }
};

export const getCommissionPlanById = async (planId) => {
  try {
    const response = await api.get(`/admin/affiliate/commissions/plans/${planId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching plan ${planId}:`, error);
    throw error;
  }
};

export const createCommissionPlan = async (payload) => {
  try {
    const response = await api.post('/admin/affiliate/commissions/plans', payload);
    return response.data;
  } catch (error) {
    console.error("Error creating commission plan:", error);
    throw error;
  }
};

export const updateCommissionPlan = async (planId, payload) => {
  try {
    const response = await api.put(`/admin/affiliate/commissions/plans/${planId}`, payload);
    return response.data;
  } catch (error) {
    console.error(`Error updating plan ${planId}:`, error);
    throw error;
  }
};

// --- AFFILIATE PLAN ASSIGNMENT ---

export const assignPlanToAffiliate = async (affiliateId, planId) => {
  try {
    // Assuming you have/will create this endpoint to update custom_plan_id on the ReferralPartner
    const response = await api.put(`/admin/affiliate/${affiliateId}/commission-plan`, {
      custom_plan_id: planId
    });
    return response.data;
  } catch (error) {
    console.error(`Error assigning plan to affiliate ${affiliateId}:`, error);
    throw error;
  }
};


// --- AFFILIATE MANAGEMENT ---

export const getAffiliatesList = async (search_term = '', skip = 0, limit = 50) => {
    try {
        const response = await api.get('/admin/affiliate/search', {
            params: { search_term, skip, limit }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching affiliates:", error);
        throw error;
    }
};

export const updateAffiliateStatus = async (affiliateId, payload) => {
    try {
        const response = await api.put(`/admin/affiliate/${affiliateId}/status`, payload);
        return response.data;
    } catch (error) {
        console.error(`Error updating status for affiliate ${affiliateId}:`, error);
        throw error;
    }
};

export const getContractorsList = async (searchTerm = '', skip = 0, limit = 50) => {
    try {
        // Calls the new dedicated endpoint
        const response = await api.get('/admin/affiliate/contractors', {
            params: { search_term: searchTerm, skip, limit }
        }); 
        return response.data;
    } catch (error) {
        console.error("Error fetching contractors:", error);
        throw error;
    }
};

// We need a specific endpoint for contractors since their ID belongs to the admin_users table
export const assignPlanToContractor = async (adminUserId, custom_plan_id) => {
    try {
        const response = await api.put(`/admin/affiliate/${adminUserId}/commission-plan`, {
            custom_plan_id: custom_plan_id
        });
        return response.data;
    } catch (error) {
        console.error(`Error assigning plan to contractor ${adminUserId}:`, error);
        throw error;
    }
};